import { utilBuildings } from "../../../utils/utilBuildings";
import { selectBuildingsWhichProducesResourceIdAvailable } from "../selectors/selectBuildingsWhichProducesResourceIdAvailable";
export var checkAnyBuildingWhichProducesResourceIdNotProducingPremiumAvailable = function (path) { return function (action, state$, dependencies) {
    var state = state$.value;
    var availableBuildings = selectBuildingsWhichProducesResourceIdAvailable(state, action.taskType.resourceId);
    var anyBuildingNotProducing = availableBuildings.some(function (building) { return utilBuildings.isNotProducing(building) && utilBuildings.isPremium(building); });
    return anyBuildingNotProducing ? path : undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/checks/checkAnyBuildingWhichProducesResourceIdNotProducingPremiumAvailable.ts
// module id = 2386
// module chunks = 3